import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Youtube, Mail, MapPin, Phone } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_pressnet/artifacts/nmfi6tck_Choluteca_net3-BLANCO.png";

const footerLinks = {
  explorar: [
    { name: "Noticias", href: "/noticias" },
    { name: "Destinos", href: "/destinos" },
    { name: "Experiencias", href: "/experiencias" },
    { name: "Sabores", href: "/sabores" },
    { name: "Videos", href: "/videos" },
    { name: "Reportar noticia", href: "/reportar" },
  ],
  regiones: [
    { name: "Choluteca", href: "/choluteca" },
    { name: "Honduras", href: "/honduras" },
  ],
  contacto: [
    { icon: MapPin, text: "Choluteca, Honduras" },
    { icon: Mail, text: "info@choluteca.net" },
    { icon: Phone, text: "+504 3246-9330" },
  ],
};

const socialLinks = [
  { icon: Facebook, href: "https://facebook.com/cholutecanet", label: "Facebook" },
  { icon: Twitter, href: "https://twitter.com/cholutecanet", label: "Twitter" },
  { icon: Instagram, href: "https://instagram.com/cholutecanet", label: "Instagram" },
  { icon: Youtube, href: "https://youtube.com/cholutecanet", label: "YouTube" },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B0F14] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src={LOGO_URL}
                alt="Choluteca.net"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              El portal digital del sur de Honduras. Noticias, destinos, cultura
              y todo lo que hace especial a nuestra región.
            </p>
            {/* Social Links */}
            <div className="flex space-x-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors"
                  aria-label={social.label}
                  data-testid={`social-${social.label.toLowerCase()}`}
                >
                  <social.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Explorar */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">Explorar</h3>
            <ul className="space-y-3">
              {footerLinks.explorar.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                    data-testid={`footer-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Regiones */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">Regiones</h3>
            <ul className="space-y-3">
              {footerLinks.regiones.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                    data-testid={`footer-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4">Contacto</h3>
            <ul className="space-y-3">
              {footerLinks.contacto.map((item, idx) => (
                <li key={idx} className="flex items-start space-x-3">
                  <item.icon className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
                  <span className="text-gray-400 text-sm">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="py-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} Choluteca.net. Todos los derechos reservados.
          </p>
          <div className="flex items-center space-x-6">
            <Link
              to="/privacidad"
              className="text-gray-500 hover:text-white text-sm transition-colors"
            >
              Privacidad
            </Link>
            <Link
              to="/terminos"
              className="text-gray-500 hover:text-white text-sm transition-colors"
            >
              Términos
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
